import { action } from "mobx";
import * as service from "./loginStore.service";
import * as utils from "./loginStore.methods";
import { Toastr } from "arv-reactcomponents";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import { Utils } from "arv-reactcomponents";
import { STORAGE_KEYS, blackboltConfig } from "../../constants";

class LoginStoreAction {
  // Login actions goes here
  WishListStore;
  MybagStore;
  constructor(WishListStore, MybagStore) {
    this.WishListStore = WishListStore;
    this.MybagStore = MybagStore;
    this.setStores = this.setStores.bind(this);
  }
  setStores(WishListStore, MybagStore) {
    this.WishListStore = WishListStore;
    this.MybagStore = MybagStore;
  }
  @action
  loginUserAction(email, password) {
    this.loader = true;
    this.setAuthError();
    const body = utils.formatLoginQuery(email, password);
    return service.login(body).then(
      action(res => {
        Analytics.trackEvent({
          action: Event.action.LOGIN_SUCCESS,
          category: Event.category.LOGIN,
        });
        this.postLogin(res);
        return res;
      }),
      action(error => {
        this.loader = false;
        const defaultErrorMsg = blackboltConfig.ERROR_MSG;
        Analytics.trackEvent({
          action: Event.action.LOGIN_ERROR,
          category: Event.category.LOGIN,
        });
        const err = error && error.errors;
        if (err && err[0] && blackboltConfig.ERROR_CODE.includes(err[0].status)) {
          const { detail = defaultErrorMsg } = err[0];
          this.setAuthError(
            true,
            detail,
          );
        } else {
          this.setAuthError(true, defaultErrorMsg);
        }
        return error;
      }),
    );
  }

  @action
  postLogin(response) {
    this.currentView = "login";
    const res = response.data;
    if (res.access_token && res.refresh_token) {
      utils.setTokens(res);
      this.setloginModal(false)
        .setLoggedInData()
        .getAccountInfo();
      // MyBagStore.getMyBagDetails();

      // TODO move this once new token data
      const decodedAccessToken = utils.decodeToken(res.access_token);
      const decodedRefreshToken = utils.decodeToken(res.refresh_token);
      this.WishListStore.wishList();
      this.WishListStore.brandWishList();
      this.accessTokenData = {
        ...this.accessTokenData,
        ...decodedAccessToken,
      };
      this.refreshTokenData = {
        ...this.refreshTokenData,
        ...decodedRefreshToken,
      };
      this.loader = false;
      if (window.goToRouteOnLogin) {
        window.location.href = `
          ${window.location.origin}/${window.goToRouteOnLogin}`;
      } else {
        this.MybagStore.getMyBagDetails();
      }
    } else {
      this.setAuthError(true, "Please enter valid Data");
    }
  }

  @action
  loginUserSocially(socialToken, type) {
    this.socialLoader = true;
    const req = JSON.stringify({
      social_token: socialToken,
      grant_type: blackboltConfig.socialGrantType,
      social_identity_provider: type,
    });
    service.socialLogin(req).then(
      action(res => {
        this.socialLoader = false;
        if (res && res.data && res.data.access_token) {
          Analytics.trackEvent({
            action: Event.action.LOGIN_SUCCESS,
            category: Event.category.LOGIN,
          });
          this.postLogin(res);
        }
      }),
      action(err => {
        const { data } = err;
        if (data) {
          const { emailId, missingFields } = data;
          Analytics.trackEvent({
            action: Event.action.MISSED_FIELDS,
            category: Event.category.LOGIN,
          });
          this.missingFieldsLogin = {
            ...this.missingFieldsLogin,
            emailId,
            missingFields,
            socialToken,
            source: type,
          };
          this.changeView("missed")
        } else {
          this.socialLoader = false;
          Analytics.trackEvent({
            action: Event.action.MISSED_FIELDS_ERROR,
            category: Event.category.LOGIN,
          });
          if (type === blackboltConfig.facebook) {
            this.changeView("socialLoginError");
            this.setAuthError(
              true,
              "Not able to get your email or phone number from facebook",
            );
          } else {
            this.changeView("socialLoginError");
            this.setAuthError(
              true,
              `Failed to Login with Gmail.
              Check your Gmail Credentials.`,
            );
          }
        }
      }),
    );
  }

  @action
  fbAction() {
    this.socialLoader = true;
    const { FB } = window;
    if (!FB) {
      this.socialLoader = false;
      Toastr.showToastr({
        className: "nwc-toastr-list-notification nw-toastr",
        message:
          "Sorry! not able to connect to Facebook. Please try login via Email or Google",
        timeout: 3000,
      });
      return null;
    }

    FB.login(
      response => {
        // TODO clean this up
        switch (response.status) {
          case "connected": {
            this.socialLoader = false;
            const { accessToken } = response.authResponse;
            this.loginUserSocially(accessToken, blackboltConfig.facebook);
            break;
          }
          case "unknown":
          case "not_authorized":
          default: {
            this.socialLoader = false;
            this.changeView("login");
            break;
          }
        }
      },
      {
        scope: "publish_actions, email",
      },
    );
    return null;
  }

  @action
  getAccountInfo() {
    return service.getAccount().then(res => {
      const { firstName: userName } = res.userInfo;
      const [email] = res.emails;
      window.localStorage.setItem("user_email", email.emailID);
      utils.createCookies({ userName }, { cust_email: email.emailID });
      this.account = {
        ...this.account,
        ...res,
      };
    });
  }

  @action
  logoutAction(interaction = false) {
    Analytics.trackEvent({
      action: Event.action.LOGOUT,
      category: Event.category.LOGIN,
      interaction,
    });
    this.account = {};
    this.isUserLoggedIn = false;

    // TODO move cookie list to constants
    utils.deleteCookies(
      "userName",
      "accessToken",
      "refreshToken",
      "cust_email",
    );
    window.localStorage.removeItem("user_email");
    Utils.localStorage.removeItem(STORAGE_KEYS.RECENTLY_VIEWED);
  }

  @action
  setAuthError(isError = false, msg = "Please enter valid Data") {
    this.authError = isError;
    this.authErrorMsg = msg;
  }

  @action
  setLoggedInData() {
    // TODO : set roles and other token extracted data

    this.isUserLoggedIn = true;
    return this;
  }

  @action
  setloginModal(value) {
    this.isModalOpen = value;
    this.setAuthError();
    return this;
  }

  @action
  forgotPasswordAction(id, type) {
    this.loader = true;
    const { headers, body } = utils.formatResetPasswordQuery(id, type);
    service.forgotPassword(headers, body).then(
      action(res => {
        Analytics.trackEvent({
          action: Event.action.FORGOT_PASSWORD_SUCCESS,
          category: Event.category.LOGIN,
        });
        this.setloginModal(false);
        this.changeView("login");
        Toastr.showToastr({
          className: "nwc-toastr-list-notification nw-toastr",
          message: `${type} sent, Please Check`,
          timeout: 3000,
        });
      }),
      action(error => {
        this.loader = false;
        const err = error && error.errors;
        if (err && err[0] && blackboltConfig.ERROR_CODE.includes(err[0].status)) {
          this.setAuthError(true, `Sorry! ${id} is not registered with us.`);
        } else {
          this.setAuthError(true, blackboltConfig.ERROR_MSG);
        }
      }),
    );
  }

  @action
  resetPasswordAction(sessionId, newPassword) {
    this.loader = false;
    const body = JSON.stringify({
      type: "password",
      value: newPassword,
    });
    service.resetPassword(sessionId, body).then(
      action(() => {
        this.changeView("login");
        Toastr.showToastr({
          className: "nwc-toastr-list-notification nw-toastr",
          message: "Your password is reset successfully.",
          timeout: 3000,
        });
      }),
      action(() => {
        this.loader = false;
        this.setAuthError(
          true,
          "Failed to reset password. Please try again later.",
        );
      }),
    );
  }

  // Register actions goes here
  @action
  userOnboard(userDetails, missingForm) {
    return new Promise((resolve, reject) => {
      this.loader = true;
      let body = {};
      if (missingForm) {
        const partialCache = this.missingFieldsLogin;
        body = utils.formatSocialQuery({...partialCache, ...userDetails});
      } else {
        body = utils.formatRegisterQuery(userDetails);
      }
      return service
        .register("registerUser", body)
        .then(
        action(res => {
          this.postLogin(res);
          Analytics.trackEvent({
            action: Event.action.REGISTER_SUCCESS,
            category: Event.category.LOGIN,
          });
          Toastr.showToastr({
            className: "nwc-toastr-list-notification nw-toastr",
            message:
              "Welcome, you're one of us NNNOW. Thanks for signing up.",
            timeout: 3000,
          });
          resolve(res);
        }),
        action(err => {
          this.loader = false;
          reject(err);
        }),
      );
    });
  }

  @action
  changeView(view, userId = "") {
    this.setAuthError();
    this.currentView = view;
    this.userId = userId;
    this.loader = false;
    this.socialLoader = false;
  }
}

export default LoginStoreAction;



// WEBPACK FOOTER //
// ./src/stores/Login/loginStore.actions.js